import {
    ModalVariant,
    OperatorRoutedModal,
} from '../ui/modal/OperatorRoutedModal.tsx';
import {
    RequestMethod,
    useServerSuccessEffect,
    useServerWrite,
} from 'dg-web-shared/lib/hooks/ServerStateHooks.ts';
import { Localized } from 'dg-web-shared/lib/Localization.tsx';
import { ParkingPortalLayoutWithHeader } from '../mobile/layout/ParkingPortalLayoutWithHeader.tsx';
import { DateTime } from 'luxon';
import { Navigate, useNavigate, useParams } from 'react-router';
import {
    OffstreetEventErrorResponse,
    OperatorOffstreetEventsCreateUpdateForm,
} from './OperatorOffstreetEventsAdd.tsx';
import { useOffstreetEventsOutlet } from './OperatorOffstreetEvents.tsx';

interface OffstreetEventEditPayload {
    eventId: string;
    name: string;
    validFrom: DateTime;
    validTo: DateTime;
}

export function OperatorOffstreetEventsEdit() {
    const navigate = useNavigate();
    const { eventId } = useParams();

    const { events, refetchEvents } = useOffstreetEventsOutlet();
    const event = events?.find(e => e.productEventId === eventId) ?? null;

    const [editOffstreetEventState, editOffstreetEvent] = useServerWrite<
        OffstreetEventEditPayload,
        unknown,
        OffstreetEventErrorResponse
    >(payload => ({
        method: RequestMethod.PUT,
        url: `/ui-api/operator-account/offstreet-events/${payload.eventId}`,
    }));
    useServerSuccessEffect(editOffstreetEventState, () => {
        refetchEvents();
        navigate('..');
    });

    if (event === null) {
        return <Navigate to=".." replace />;
    }

    return (
        <OperatorRoutedModal
            variant={ModalVariant.TINY}
            backUrl={'..'}
            style={{ maxHeight: undefined }}
            render={() => (
                <ParkingPortalLayoutWithHeader
                    title={
                        <Localized
                            de="Veranstaltung bearbeiten"
                            fr="Modifier manifestation"
                            it="Modifica evento"
                            en="Edit event"
                        />
                    }
                    backTo={'..'}
                >
                    <OperatorOffstreetEventsCreateUpdateForm
                        submitRequestState={editOffstreetEventState}
                        onSubmit={({ name, validTo, validFrom }) => {
                            if (validTo == null || validFrom == null) {
                                throw new Error(
                                    'Required form fields are missing on submit',
                                );
                            }
                            editOffstreetEvent({
                                eventId: event.productEventId,
                                name,
                                validTo,
                                validFrom,
                            });
                        }}
                        defaultValues={{
                            contractTemplateId: event.contractTemplateId,
                            name: event.eventName,
                            validFrom: DateTime.fromISO(event.validFrom),
                            validTo: DateTime.fromISO(event.validTo),
                        }}
                        productOptions={[
                            {
                                contractTemplateId: event.contractTemplateId,
                                productName: event.productName,
                            },
                        ]}
                    />
                </ParkingPortalLayoutWithHeader>
            )}
        />
    );
}
